import { render, staticRenderFns } from "./MarketingIcon.vue?vue&type=template&id=6d983328"
import script from "./MarketingIcon.vue?vue&type=script&lang=js"
export * from "./MarketingIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports